import { render, staticRenderFns } from "./CurveView.vue?vue&type=template&id=e36ec07e&scoped=true"
import script from "./CurveView.vue?vue&type=script&lang=js"
export * from "./CurveView.vue?vue&type=script&lang=js"
import style0 from "./CurveView.vue?vue&type=style&index=0&id=e36ec07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36ec07e",
  null
  
)

export default component.exports